'use strict';

import pkg from '../../package.json';

let version = pkg.version

export { version };
